<button
  class="picture-overlay"
  [matMenuTriggerFor]="menu"
  data-testid="conversation-picture"
  aria-label="Edit group photo"
>
  <div class="image-wrapper">
    @if (!pictureId) {
      <img
        class="image"
        src="../../../../../assets/icons/icongroup.svg"
        alt="Default group photo"
        data-testid="conversation-photo-placeholder"
      />
    }
    @if (!!pictureId) {
      <img
        class="image"
        [src]="pictureUri | clink | secure"
        alt="Group photo"
        data-testid="conversation-photo-image"
      />
    }
  </div>
  <div class="banner-text">
    Edit photo
    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="createEditDialog()">Choose Photo</button>
      <button mat-menu-item (click)="removePhoto()">Remove Photo</button>
    </mat-menu>
  </div>
  <input
    #fileInput
    type="file"
    accept=".png,.jpg,.jpeg,.jfif"
    hidden
    (change)="handleFileUpload()"
  />
</button>
